import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header.jsx';
import Footer from './components/footer.jsx';
import Home from './pages/Home/Home.jsx';
import AboutUs from './pages/About/About.jsx';
import GoverningBodies from './pages/OurTeam/Governing.jsx';
import LifeMembers from './pages/OurTeam/LifeMembers.jsx';
import NationalMember from './pages/OurTeam/NationalMember.jsx';
import ActiveMembers from './pages/OurTeam/ActiveMember.jsx';
import PastEvents from './pages/PastEvents/PastEvents.jsx';
import PastVideos from './pages/PastEvents/PastVideos.jsx';
import SteelHandbook from './pages/SteelHandbook/page.jsx';
import ContactSection from './pages/Contact/page.jsx';
import Newsletter2016 from './pages/Newsletters/Newsletter2016.jsx';
import Newsletter2017 from './pages/Newsletters/Newsletter2017.jsx';
import Newsletter2018 from './pages/Newsletters/Newsletter2018.jsx';
import Newsletter2019 from './pages/Newsletters/Newsletter2019.jsx';
import Newsletter2020 from './pages/Newsletters/Newsletter2020.jsx';
import Newsletter2021 from './pages/Newsletters/Newsletter2021.jsx';
import Newsletter2022 from './pages/Newsletters/Newsletter2022.jsx';
import Newsletter2023 from './pages/Newsletters/Newsletter2023.jsx';
import Newsletter2024 from './pages/Newsletters/Newsletter2024.jsx';
import Newsletter2025 from './pages/Newsletters/Newsletter2025.jsx';
import PartnersSection from './pages/Partners/PartnersSection.jsx';
import TermsAndConditions from './pages/policy/TermsAndConditions.jsx';
import PrivacyPolicy from './pages/policy/PrivacyPolicy.jsx';
import RefundPolicy from './pages/policy/RefundPolicy.jsx';
import AaiifaEvent2023 from './pages/PastEvents/aaiifa-event-2023.jsx';
import AaiifaEvent2024 from './pages/PastEvents/aaiifa-event-2024.jsx';
import AaiifaEvent2025 from './pages/PastEvents/aaiifa-event-2025.jsx';
import EventGallery2022 from './pages/PastEvents/PastEvent2022.jsx';
import EventGallery2019 from './pages/PastEvents/PastEvent2019.jsx';
import EventGallery2018 from './pages/PastEvents/PastEvent2018.jsx';
import EventGallery2017 from './pages/PastEvents/PastEvent2017.jsx';
import EventGallery2016 from './pages/PastEvents/PastEvent2016.jsx';
import Breadcrumb from './components/Breadcrumb.jsx';
import ThankYouPopup from './components/ThankYouPopup.jsx';
import AIIFAMembershipForm  from './pages/JoinUsForm/JoinUs';
import Newsletter from './pages/Newsletters/Newsletter.jsx';
import PastVideos2025 from './pages/PastEvents/PastVideos2025.jsx';
import PastVideos2024 from './pages/PastEvents/PastVideos2024.jsx';
import PastVideos2023 from './pages/PastEvents/PastVideos2023.jsx';
import PastSteelExTeaser from './pages/PastEvents/PastSteelExTeaser.jsx';
import MemberDetails from "./pages/OurTeam/MemberDetails.jsx";
import ScrollToTop from "./components/ScrollToTop";
import DayOne2023 from "./pages/PastEvents/event-2023/DayOne.jsx";
import Daytwo2023 from "./pages/PastEvents/event-2023/DayTwo.jsx";
import DayOne2024 from "./pages/PastEvents/event-2024/DayOne.jsx";
import Daytwo2024 from "./pages/PastEvents/event-2024/DayTwo.jsx";
import DayOne2025 from "./pages/PastEvents/event-2025/DayOne.jsx";
import Daytwo2025 from "./pages/PastEvents/event-2025/DayTwo.jsx";
import GreenSteelAwardee from "./pages/green-steel-awardee/GreenSteelAwardee.jsx";
import Consultants from "./pages/Consultants/Consultants.jsx";
import RecentInitiative from './pages/PastEvents/RecentInitiative.jsx';
import BharatSteelExpo from './pages/BharatSteelExpo/BharatSteelExpo.jsx';
import BharatBuildcon from './pages/BharatBuildcon/BharatBuildcon.jsx';
import Popup from './pages/Popup/Popup.jsx';
import Article1 from './pages/Articles/Article1.jsx';
import Article2 from './pages/Articles/Article2.jsx';
import Article3 from './pages/Articles/Article3.jsx';
import Article4 from './pages/Articles/Article4.jsx';
import Article5 from './pages/Articles/Article5.jsx';

import SteelSecretary from "./pages/PastEvents/SteelSecretary.jsx";
import PlantVisit from "./pages/PastEvents/PlantVisit.jsx";
import SustainableQuality from "./pages/PastEvents/SustainableQuality.jsx";
import KashiVishwanathSteels from './pages/KashiVishwanathSteels/KashiVishwanathSteels.jsx';
import SBFIspatPrivateLimited from './pages/SBFIspatPrivateLimited/SBFIspatPrivateLimited.jsx';


// ✅ Inner component to access `useLocation` properly
function AppContent() {
  const location = useLocation();
  const showBreadcrumb = location.pathname !== "/";

  return (
    <>
      <Header />
      {showBreadcrumb && <Breadcrumb />}
      {!showBreadcrumb && <Popup />}
      <ThankYouPopup />
      {/* <Popup /> */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="about-industry" element={<AboutUs />} />
        <Route path="governing-bodies" element={<GoverningBodies />} />
        <Route path="life-members" element={<LifeMembers />} />
        <Route path="national-member" element={<NationalMember />} />
        <Route path="active-member" element={<ActiveMembers />} />
        <Route path="past-events" element={<PastEvents />} />
        <Route path="past-videos" element={<PastVideos />} />
        <Route path="steel-handbook" element={<SteelHandbook />} />
        <Route path="contact" element={<ContactSection />} />
        <Route path="newsletter-2016" element={<Newsletter2016 />} />
        <Route path="newsletter-2017" element={<Newsletter2017 />} />
        <Route path="newsletter-2018" element={<Newsletter2018 />} />
        <Route path="newsletter-2019" element={<Newsletter2019 />} />
        <Route path="newsletter-2020" element={<Newsletter2020 />} />
        <Route path="newsletter-2021" element={<Newsletter2021 />} />
        <Route path="newsletter-2022" element={<Newsletter2022 />} />
        <Route path="newsletter-2023" element={<Newsletter2023 />} />
        <Route path="newsletter-2024" element={<Newsletter2024 />} />
        <Route path="newsletter-2025" element={<Newsletter2025 />} />
        <Route path="our-partner" element={<PartnersSection />} />
        <Route path="terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="privacy-policy" element={<PrivacyPolicy />} />
        <Route path="refund-policy" element={<RefundPolicy />} />
        <Route path="aaiifa-event-2023" element={<AaiifaEvent2023 />} />
        <Route path="aaiifa-event-2024" element={<AaiifaEvent2024 />} />
        <Route path="aaiifa-event-2025" element={<AaiifaEvent2025 />} />
        <Route path="past-event-2022" element={<EventGallery2022 />} />
        <Route path="past-event-2019" element={<EventGallery2019 />} />
        <Route path="past-event-2018" element={<EventGallery2018 />} />
        <Route path="past-event-2017" element={<EventGallery2017 />} />
        <Route path="past-event-2016" element={<EventGallery2016 />} />
        <Route path="join-us" element={<AIIFAMembershipForm />} />
        <Route path="/newsletter" element={<Newsletter />} />
        <Route path="/past-videos-2025" element={<PastVideos2025 />} />
        <Route path="/past-videos-2024" element={<PastVideos2024 />} />
        <Route path="/past-videos-2023" element={<PastVideos2023 />} />
        <Route path="/steelex-teasers" element={<PastSteelExTeaser />} />
        <Route path="/member/:slug" element={<MemberDetails />} />
        <Route path="/member/:slug" element={<MemberDetails />} />
        <Route path="/day-1-2023" element={<DayOne2023 />} />
        <Route path="/day-2-2023" element={<Daytwo2023 />} />
        <Route path="/day-1-2024" element={<DayOne2024 />} />
        <Route path="/day-2-2024" element={<Daytwo2024 />} />
        <Route path="/day-1-2025" element={<DayOne2025 />} />
        <Route path="/day-2-2025" element={<Daytwo2025 />} />
        <Route path="/green-steel-awardee" element={<GreenSteelAwardee />} />
        <Route path="/consultants" element={<Consultants />} />
        <Route path="/recent-initiative" element={<RecentInitiative />} />
        <Route path="/kashi-vishwanath-steels-ltd" element={<KashiVishwanathSteels />} />
        <Route path="/sbf-ispat-private-limited" element={<SBFIspatPrivateLimited />} />

        <Route
          path="/steel-secretary-shri-sandeep-poundrik-visits-moira-steel-indore-on-23-october-2025"
          element={<SteelSecretary />}
        />

        <Route
          path="/plant-visit-and-brainstorming-session-on-steel-sector-development-delhiup-on-14-november-2025"
          element={<PlantVisit />}
        />

        <Route
          path="/sustainable-quality-steelmaking-conference23rd-24th-april-2026-in-jamshedpur-jharkhand"
          element={<SustainableQuality />}
        />

        <Route path="/bharat-steelexpo-2026" element={<BharatSteelExpo />} />
        <Route path="/bharat-buildcon-2026" element={<BharatBuildcon />} />
        <Route path="/article-1" element={<Article1 />} />
        <Route path="/article-2" element={<Article2 />} />
        <Route path="/article-3" element={<Article3 />} />
        <Route path="/article-4" element={<Article4 />} />
        <Route path="/article-5" element={<Article5 />} />
      </Routes>
      <Footer />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
    <ScrollToTop />
      <AppContent />
    </BrowserRouter>
  );
}

export default App;